import React from 'react';
import StatusDotProfileCmp from 'src/components/StatusDotProfileCmp';
import TruncateTextCmp from 'src/components/TruncateText';
import { formatAddress } from 'src/utils/CommonFunctions';

import { ITrackOrder } from './track.slice';

interface IProps {
    order: ITrackOrder;
    isHovered?: boolean;
}

const ShipperConsigneeBox = ({ order, isHovered }: IProps) => {
    const shipperLabelRef = React.useRef<HTMLDivElement>(null);
    const consigneeLabelRef = React.useRef<HTMLDivElement>(null);

    const origin = order?.originAddress;
    const destination = order?.destinationAddress;

    const shipperLabel = `${origin?.companyName ? `${origin.companyName}` : ''}${origin?.city ? `, ${formatAddress(origin.city)}` : ''}${origin?.stateCode ? `, ${origin.stateCode}` : ''}${
        origin?.postal ? `, ${formatAddress(origin.postal)}` : ''
    }`;
    const consigneeLabel = `${destination?.companyName ? `${destination.companyName}` : ''}${destination?.city ? `, ${formatAddress(destination.city)}` : ''}${
        destination?.stateCode ? `, ${destination.stateCode}` : ''
    }${destination?.postal ? `, ${formatAddress(destination.postal)}` : ''}`;

    return (
        <div className="w-full">
            <div
                className={`rounded-lg border p-3 transition-all duration-200 bg-gray50 shadow-[inset_0_2px_4px_-2px_rgba(16,24,40,0.06)] ${
                    isHovered ? 'border-indigo400 shadow-[0_0_0_3px_rgba(68,76,231,0.12),inset_0_2px_4px_-2px_rgba(16,24,40,0.06)]' : 'border-utilityGray200'
                }`}
            >
                <ul className="space-y-0.5">
                    <li className="relative flex items-start gap-x-3 overflow-hidden">
                        <div className="after:content-[''] after:h-full after:w-[2px] after:rounded-sm after:top-0 after:absolute flex items-center justify-center after:border-gray400 after:border-dashed after:border-l">
                            <div className="w-[20px] h-[20px] bg-gray50 flex justify-center items-center z-[2]">
                                <StatusDotProfileCmp dotColor="green" />
                            </div>
                        </div>
                        <div className="flex-1 text-grayLight900 text-xs font-medium overflow-hidden">
                            <TruncateTextCmp refName={shipperLabelRef} message={shipperLabel || ''}>
                                <div className="text-textSecondary text-[12px] leading-[18px] font-normal truncate cursor-default" ref={shipperLabelRef}>
                                    {shipperLabel || ''}
                                </div>
                            </TruncateTextCmp>
                        </div>
                    </li>
                    <li className="relative flex items-center gap-x-3 pb-0 overflow-hidden !-my-[7px]">
                        <div className="after:content-[''] after:h-full after:w-[2px] after:rounded-sm after:top-0 after:absolute flex items-center justify-center after:border-gray400 after:border-dashed after:border-l">
                            <div className="w-[20px] h-[20px] flex justify-center items-center"></div>
                        </div>
                        <div className="flex-1 flex items-center gap-x-4">
                            <p className="flex-1 border-t border-utilityGray100"></p>
                        </div>
                    </li>
                    <li className="relative flex items-start gap-x-3 pb-6 last:pb-0 overflow-hidden">
                        <div className="after:content-[''] after:h-0 after:w-[2px] after:rounded-sm after:top-0 after:absolute flex items-center justify-center after:bg-successSecondary">
                            <div className="w-[20px] h-[20px] bg-gray50 flex justify-center items-center z-[2]">
                                <StatusDotProfileCmp dotColor="primary" />
                            </div>
                        </div>
                        <div className="flex-1 text-grayLight900 text-xs font-medium overflow-hidden">
                            <TruncateTextCmp refName={consigneeLabelRef} message={consigneeLabel || ''}>
                                <div className="text-textSecondary text-[12px] leading-[18px] font-normal truncate cursor-default" ref={consigneeLabelRef}>
                                    {consigneeLabel || ''}
                                </div>
                            </TruncateTextCmp>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default ShipperConsigneeBox;
